// extracted by mini-css-extract-plugin
module.exports = {"md":"768px","lg":"1280px","root":"mf-PG","header":"mf-PH","controls":"mf-PI","swiper":"mf-PJ","news":"mf-PK","grants":"mf-PL","highlight":"mf-PM","slide":"mf-PN","cta":"mf-PO"};